import { MarginApiResponse } from '@store/refinanciamento/marginAcceptResult/types'

import { BaseServices } from './base'
import { HttpMethod, TResponseType } from './base/types'
import { BridgeService } from './bridge'

export interface MarginAcceptRequestBody {
  income?: number
  selectedContracts?: string[]
}

export interface MarginApiParams {
  convenioName: string
  accessToken?: string
  selectedContracts?: string[]
}

export default ({
  convenioName,
  accessToken,
  selectedContracts,
}: MarginApiParams): Promise<TResponseType<MarginApiResponse>> => {
  const pathname = `${process.env.REACT_APP_MARGIN_ACCEPT_RESULT}/${convenioName}/query/accept`
  const method = HttpMethod.POST
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}
  const body: MarginAcceptRequestBody = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  if (selectedContracts && selectedContracts.length > 0) {
    body.selectedContracts = selectedContracts
  }

  return BaseServices.request<MarginApiResponse>({
    headers,
    pathname,
    method,
    host,
    data: body,
  })
}
